import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT} from '../../../style/typography';
import {CHARCOAL, TARMAC} from '../../../style/colors';
import {PHONE} from '../../../style/breakpoints';
import glamorous from 'glamorous';
import MITIcon from '../../icons/MIT.svg';

const Container = glamorous.div({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  ' > div:first-of-type': {
    marginLeft: 0
  }
});

const Item = glamorous.div({
  display: 'block',
  flexDirection: 'row',
  alignItems: 'center'
});

const ItemLabel = glamorous.div({
  ...BASE_TEXT,
  color: TARMAC,
  fontSize: 13,
  lineHeight: '28px',
  marginRight: 8
});

const Stat = glamorous.div({
  ...BASE_TEXT,
  fontSize: 13,
  color: CHARCOAL,
  fontWeight: 'bold',
  marginRight: 5,
  marginTop: 3,
  [PHONE]: {
    fontSize: 13
  }
});

const MITContent = glamorous.div({
  display: 'inline-flex'
});

const MITIconStyled = glamorous(MITIcon)({
  marginRight: 5,
  height: 'auto'
});

const MITText = glamorous.div({
  color: TARMAC,
  fontSize: 13
});

const StatsReleaseInfo = ({items, license}) => {
  return (
    <Container>
      {items.map(({stat, label}, index) => (
        <Fragment key={index}>
          <Item key={index}>
            <div style={{display: 'flex'}}>
              <ItemLabel>{label}</ItemLabel>
              <Stat>{stat}</Stat>
            </div>{' '}
            {license !== null ? (
              <>
                <MITContent>
                  <MITIconStyled /> <MITText>{license.name}</MITText>
                </MITContent>
              </>
            ) : (
              ''
            )}
          </Item>
        </Fragment>
      ))}
    </Container>
  );
};

StatsReleaseInfo.propTypes = {
  license: PropTypes.object,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      stat: PropTypes.any
    })
  )
};

export default StatsReleaseInfo;
